import AuthorSmall from './Author/AuthorSmall'
import Cateogaries from './Cateogary Component/Cateogaries'
import './post.css'
import PostHeadingAndOtherStuff from './Post Section/PostHeadingAndOtherStuff'
import PostWithContent from './Post Section/PostWithContent'
import RecentPosts from './Recent Posts Component/RecentPosts'
import data from '../FakeData/index.json'
import ImageReturn from './ImageReturn'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks'
import PostHeadingAndOtherStuffSkeleton from './Post Section/PostHeadingAndOtherStuffSkeleton'
import ImageReturnSkeleton from './ImageReturnSkeleton'
import PostWithContentSkeleton from './Post Section/PostWithContentSkeleton'
import Comment from './Comments/Comment'
import { Helmet } from 'react-helmet'

function Post({ match }) {


    let keywords = `coding, blog, react, react js, python, python3, django, restful api, developer, developement, flutter, next, next js, react.js, next.js, python 3, server, deployment, java, javascript, dev, hashnode, blogging`;


    const timing = setTimeout(() => {
        if (!document.getElementById('blogs').classList.contains('active')) {
            document.getElementById("blogs").className += 'active';
        }
    }, 100);


    let description = ``;
    const { blogs, loading } = UseFetch(`${mainData.searchByPost}${match.params.name}`)
    if (!loading) {
        description = blogs.Content;
    }
    if (!loading) {
        clearTimeout(timing)
    }

    if (!loading) {
        document.title = `${blogs.Headline} | ${data[0].name}`
    }

    return (
        <section className="text-11 py-5">
            <Helmet>
                <title>
                    {match.params.name} | {data[0].name}
                </title>
                <meta name='description' content={description} />
                <meta name='keywords' content={keywords} />
                <meta property="og:site_name" content="Down the Code | Blog for Developers" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content='https://downthecode.netlify.app' />
                <meta property="og:description" content={description} />
                <meta property="og:title" content={match.params.name} />
            </Helmet>
            <div className="text11 py-lg-5 py-md-4">
                <div className="container">


                    {!loading && <PostHeadingAndOtherStuff key={blogs.id} PostName={blogs.Headline} date={blogs.date} time={blogs.Time} author={data[0].authorName} cateogary={blogs.Cateogary} />}
                    {loading && <PostHeadingAndOtherStuffSkeleton key={`PostHeadingSkeleton1`} />}


                </div>

                {loading && <ImageReturnSkeleton key={`ImageSkeleton1`} />}
                {!loading && <ImageReturn key={blogs.id} image={blogs.Image} />}

                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">

                            {/* Main Post and Image  */}
                            {!loading && <PostWithContent key={blogs.id} slug={blogs.slug} PostHead={blogs.Headline} idd={blogs.id} PostContent={blogs.Content} hashtag1={blogs.Hashtag} hashtag2={blogs.Hashtag2} hashtag3={blogs.Hashtag3} facebook={data[0].social.facebook} twitter={data[0].social.twitter} linkedin={data[0].social.linkedin} />}
                            {loading && <PostWithContentSkeleton key={`PostHeadingSkeleton2`} />}
                            {/* <PostWithContent /> */}






                        </div>
                        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12 mt-lg-0 mt-5">
                            <aside className="sidebar">




                                {/* Author Component  */}
                                <AuthorSmall key={`AuthorKey1`} author={data[0].authorName} description={data[0].authorIntro} />





                                {/* Cateogary Component  */}
                                <Cateogaries key={`Cateogaries1`} />
                                {/* <Cateogaries /> */}





                                {/* Recent Posts Component  */}
                                <RecentPosts key={`RecentPosts1`} />





                                {/* Recent Twitter Feed  */}
                                {/* <TwitterComponent /> */}

                            </aside>
                        </div>
                    </div>


                    {blogs.id && <Comment key={blogs.id} id={blogs.id} slug={blogs.slug} cateogary={blogs.Cateogary} PostHead={blogs.Headline} hashtag1={blogs.Hashtag} />}



                </div>
            </div>
        </section>

    )
}

export default Post
